import React from "react";

class LandingHeader extends React.Component {
    render() {
        return (
            <>
                <div className="top-bar-area bg-dark text-light">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 logo-box">
                                <div className="logo">
                                    <a href="/"><img src="assets/edocom/img/logo.png" alt="Thumb" /></a>
                                </div>
                            </div>
                            <div className="col-md-8 address-info text-right">
                                <div className="info">
                                    <ul>
                                        <li>
                                            <i className="fas fa-phone"></i> Contact: <strong>+91 7477893990</strong>
                                        </li>
                                    </ul>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>

                <header id="home">
                    <nav className="navbar navbar-default logo-less small-pad wrap-sticky bootsnav">
                        <div className="container">
                            <div className="attr-nav inc-btn">
                                <ul>
                                    <li>
                                        <a href="/signup">Signup</a>
                                    </li>
                                    <li>
                                        <a href="/signin">Signin</a>
                                    </li>
                                </ul>
                            </div>        
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
                                    <i className="fa fa-bars"></i>
                                </button>
                                <a className="navbar-brand" href="index.html">
                                    <img src="assets/edocom/img/logo.png" className="logo" alt="Logo" />
                                </a>
                            </div>
                            <div className="collapse navbar-collapse" id="navbar-menu">
                                <ul className="nav navbar-nav navbar-left" data-in="#" data-out="#">
                                    <li className="dropdown">
                                        <a href="/">Home</a>
                                    </li>
                                    <li className="dropdown">
                                        <a href="/#" className="dropdown-toggle" data-toggle="dropdown">About Us</a>
                                        <ul className="dropdown-menu">
                                            <li><a href="/know_us">Know Us</a></li>
                                            <li><a href="/our_story">Our Story</a></li>
                                        </ul>
                                    </li>
                                    <li className="dropdown">
                                        <a href="/#" className="dropdown-toggle" data-toggle="dropdown">Account</a>
                                        <ul className="dropdown-menu">
                                            <li><a href="/signin">Signin</a></li>
                                            <li><a href="/signup">Signup</a></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/contact">Contact</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>
            </>
        );
    }
}

export default LandingHeader;